module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2-ed121c11b6151e1f0d32b5b25eba39e9.jpg";